import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import scrollToComponent from 'react-scroll-to-component';

/* Common */
import { Modal } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

/* Components */
import WithFlow from 'conversie-flow-bundle/assets/js/components/flow/WithFlow';
import ConversionFlowForm from '../../conversion-flow/components/ConversionFlowForm';
import ConversionFlowFormVDP from './ConversionFlowFormVDP';
import { CircularProgress } from '@material-ui/core';
import ConversionFlowDataLayer from '../../conversion-flow/components/ConversionFlowDataLayer';

export default function ConversionFlowVDP({ conversionsVdp }) {
    const { ...form } = useForm({ shouldUnregister: true });
    const [activeConversion, setActiveConversion] = useState(null);
    const [conversions, setConversions] = useState([]);
    const [subConversions, setSubConversions] = useState([]);

    useEffect(() => {
        if (!conversionsVdp) return;
        const newConversions = [];
        conversionsVdp.forEach((conversion) => {
            if (!conversion.group) newConversions.push(conversion);
        });

        conversionsVdp.forEach((conversion) => {
            if (conversion.group) {
                newConversions.find((groupConversion) => {
                    if (groupConversion.name === conversion.group) groupConversion.flows.push(conversion);
                });
            }
        });

        const activeConversions = newConversions.filter((conversion) => conversion.active);

        if (activeConversions.length > 0) {
            setActiveConversion(activeConversions[0]);
        }

        setConversions(newConversions);
    }, []);

    const toggleConversion = (flow) => {
        setSubConversions([]);

        let newActiveConversion = null;
        let newConversions = conversions;
        newConversions.forEach((conversion) => conversion.active = false);

        const currentConversion = newConversions.find((conversion) => conversion.name === flow);
        currentConversion.active = true;
        newActiveConversion = currentConversion;

        if (currentConversion.flows) {
            currentConversion.flows[0].active = true
            newActiveConversion = currentConversion.flows[0];
            setSubConversions(currentConversion.flows);
        }

        setTimeout(() => {
            setConversions([]);
            setConversions(newConversions);
            setActiveConversion(null);
            setActiveConversion(newActiveConversion);
        });
    }

    const toggleSubConversion = (flow) => {
        let newSubConversions = subConversions;
        newSubConversions.forEach((conversion) => conversion.active = false);
        const currentSubConversion = newSubConversions.find((conversion) => conversion.name === flow);
        currentSubConversion.active = true;

        setTimeout(() => {
            setSubConversions([]);
            setSubConversions(newSubConversions);
            setActiveConversion(null);
            setActiveConversion(currentSubConversion);
        });
    }

    return (
        <div>
            <span className="flow__label mb-2 mb-xl-3">{trans('app.flow.flow_question')}</span>
            <div className="row gutters-0">
                <div className="col-12">
                    <div className="row gutters-0 custom-buttons">
                        {conversions.map((conversion, index) => (
                            <div className="col" key={index}>
                                <button
                                    onClick={(e) => {
                                        toggleConversion(conversion.name);
                                        scrollToComponent(e.target, {
                                            offset: -200,
                                            align: 'top',
                                            ease: 'inOutCirc',
                                        });
                                    }}
                                    className={`btn btn--flow ${conversion.active && 'is-active'}`}>
                                    {conversion.name}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {(subConversions && subConversions.length > 0) && (
                <div className="my-5">
                    <span className="flow__label mb-2 mb-xl-3">{trans('app.flow.lease_question')}</span>
                    <div className="row gutters-0">
                        <div className="col-12">
                            <div className="row gutters-0 custom-buttons">
                                {subConversions.map((conversion, index) => (
                                    <div className="col" key={index}>
                                        <button
                                            onClick={(e) => {
                                                toggleSubConversion(conversion.name);
                                                scrollToComponent(e.target, {
                                                    offset: -200,
                                                    align: 'top',
                                                    ease: 'inOutCirc',
                                                });
                                            }}
                                            className={`btn btn--flow ${conversion.active && 'is-active'}`}>
                                            {conversion.label}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {activeConversion && (
                <WithFlow
                    flowUrl={activeConversion.flowUrl}
                    flow={null}
                    translate={trans}
                >
                    {(passProps) => {
                        const { flow, setStep } = passProps;
                        const activeStep = flow?.steps?.find((step) => step.active);
                        const handleClose = () => {
                            const firstStep = flow?.steps?.find((step) => step?.position === 1);
                            setStep(firstStep);
                        }

                        return (
                            <>
                                {(flow && flow.flowName !== 'vdp_buy_online' && activeStep?.position <= 1) && (
                                    <ConversionFlowDataLayer activeStepId={flow?.steps?.find(step => step.active)?.id} flow={flow} />
                                )}
                                {!flow && (
                                    <CircularProgress
                                        classes={{
                                            root: "loading loading--circular",
                                        }}
                                    />
                                )}
                                <ConversionFlowFormVDP
                                    {...passProps}
                                    form={form}
                                    conversion={activeConversion}
                                    handleClose={handleClose}
                                />
                                <Modal
                                    open={activeStep?.position > 1}
                                    handleClose={handleClose}
                                    className={'flow__modal'}
                                    modalTitle={flow?.flowTitle || trans(`app.modal.loading`)}
                                    modalBody={
                                        <>
                                            <ConversionFlowForm
                                                {...passProps}
                                                form={form}
                                                inPage={activeStep?.position <= 1 ? true : false}
                                                handleClose={handleClose}
                                            />
                                        </>
                                    }
                                />
                            </>
                        )
                    }}
                </WithFlow >
            )}
        </div>
    )
}
